import { useContext } from 'react'
import { BreadCrumbContext } from './Breadcrumb.context'

const useBreadCrumbs = () => {
    const { setCrumbButtons, setCrumbs } = useContext<any>(BreadCrumbContext)
    return {
        setCrumbButtons,
        setCrumbs,
    }
}

export default useBreadCrumbs
